/*
 * Reads a JSON value the server rendered into the page as
 *   <script type="application/json" id="...">{...}</script>
 *
 * A JSON block is data, never executed, so the content policy does not apply
 * to it. It replaced inline `<script>window.x = {...};</script>` blocks, which
 * `script-src 'self'` blocks. The server encodes with JSON_HEX_TAG, so the
 * payload cannot close the element early.
 *
 * Returns `fallback` when the element is absent or does not parse.
 */
export function readPageData(id, fallback = null) {
  const el = document.getElementById(id);
  if (!el) {
    return fallback;
  }
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    return fallback;
  }
}
